var _desc, _rect, _defs, _text, _text2, _text3, _text4, _rect2, _text5, _path, _path2, _path3, _path4, _path5, _polyline, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _text6, _text7, _text8, _text9, _text0, _text1, _text10, _text11, _rect3, _text12, _text13, _text14, _text15, _path6, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _path7, _text32, _text33, _text34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 560 384",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    fontFamily: "Inter, system-ui, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustrated view of the Kawnter sales screen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A sales summary for a date range: total takings with order and item counts, a takings-over-time line chart, and a table listing each product with units sold and amount.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 384,
    rx: 10,
    fill: "#F4F7F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fadeT",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2E9B9B",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E9B9B",
    stopOpacity: 0
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 26,
    fontSize: 12.5,
    fontWeight: 700,
    fill: "#14344B"
  }, "Sales Summary")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 26,
    fontSize: 9.5,
    fill: "#8AA0AE"
  }, "19 Sep 2026 \u2014 25 Sep 2026")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 58,
    fontSize: 24,
    fontWeight: 700,
    fill: "#14344B"
  }, "\u20B1814.40")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 58,
    fontSize: 9.5,
    fill: "#8AA0AE"
  }, "10 orders \xB7 28 items sold")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 70,
    width: 536,
    height: 146,
    rx: 11,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 88,
    fontSize: 10,
    fontWeight: 600,
    fill: "#8AA0AE"
  }, "Takings over time")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 104 H532",
    stroke: "#F1F5F7",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 128 H532",
    stroke: "#F1F5F7",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 152 H532",
    stroke: "#F1F5F7",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 176 H532",
    stroke: "#F1F5F7",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 196 L122 192 L204 104 L286 120 L368 176 L450 186 L532 166 L532 200 L40 200 Z",
    fill: "url(#fadeT)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "40 196 122 192 204 104 286 120 368 176 450 186 532 166",
    fill: "none",
    stroke: "#2E9B9B",
    strokeWidth: 2.4,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 196,
    r: 3.2,
    fill: "#2E9B9B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 192,
    r: 3.2,
    fill: "#2E9B9B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 104,
    r: 3.2,
    fill: "#2E9B9B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 120,
    r: 3.2,
    fill: "#2E9B9B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 368,
    cy: 176,
    r: 3.2,
    fill: "#2E9B9B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 186,
    r: 3.2,
    fill: "#2E9B9B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 532,
    cy: 166,
    r: 3.2,
    fill: "#2E9B9B"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 204,
    y: 94,
    fontSize: 9.5,
    fontWeight: 700,
    fill: "#14344B",
    textAnchor: "middle"
  }, "\u20B1414.40")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 211,
    fontSize: 8,
    fill: "#8AA0AE",
    textAnchor: "middle"
  }, "Sep 19")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 122,
    y: 211,
    fontSize: 8,
    fill: "#8AA0AE",
    textAnchor: "middle"
  }, "Sep 20")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 204,
    y: 211,
    fontSize: 8,
    fill: "#8AA0AE",
    textAnchor: "middle"
  }, "Sep 21")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 286,
    y: 211,
    fontSize: 8,
    fill: "#8AA0AE",
    textAnchor: "middle"
  }, "Sep 22")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 368,
    y: 211,
    fontSize: 8,
    fill: "#8AA0AE",
    textAnchor: "middle"
  }, "Sep 23")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 211,
    fontSize: 8,
    fill: "#8AA0AE",
    textAnchor: "middle"
  }, "Sep 24")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 532,
    y: 211,
    fontSize: 8,
    fill: "#8AA0AE",
    textAnchor: "middle"
  }, "Sep 25")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 226,
    width: 536,
    height: 146,
    rx: 11,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 246,
    fontSize: 8.5,
    fontWeight: 600,
    fill: "#8AA0AE",
    textAnchor: "start"
  }, "PRODUCT")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 246,
    fontSize: 8.5,
    fontWeight: 600,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "UNITS")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 246,
    fontSize: 8.5,
    fontWeight: 600,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "PRICE")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 534,
    y: 246,
    fontSize: 8.5,
    fontWeight: 600,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "AMOUNT")), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26 254 H534",
    stroke: "#E9EFF2"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 274,
    fontSize: 10.5,
    fill: "#14344B"
  }, "Pocari sweat")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 274,
    fontSize: 10.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "7")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 274,
    fontSize: 10.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "\u20B140")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 534,
    y: 274,
    fontSize: 10.5,
    fontWeight: 600,
    fill: "#14344B",
    textAnchor: "end"
  }, "\u20B1280")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 297,
    fontSize: 10.5,
    fill: "#14344B"
  }, "Nova")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 297,
    fontSize: 10.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "5")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 297,
    fontSize: 10.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "\u20B125")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 534,
    y: 297,
    fontSize: 10.5,
    fontWeight: 600,
    fill: "#14344B",
    textAnchor: "end"
  }, "\u20B1125")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 320,
    fontSize: 10.5,
    fill: "#14344B"
  }, "Piatos")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 320,
    fontSize: 10.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "5")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 320,
    fontSize: 10.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "\u20B125")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 534,
    y: 320,
    fontSize: 10.5,
    fontWeight: 600,
    fill: "#14344B",
    textAnchor: "end"
  }, "\u20B1125")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 343,
    fontSize: 10.5,
    fill: "#14344B"
  }, "Chippy")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 343,
    fontSize: 10.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "2")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 343,
    fontSize: 10.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "\u20B120")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 534,
    y: 343,
    fontSize: 10.5,
    fontWeight: 600,
    fill: "#14344B",
    textAnchor: "end"
  }, "\u20B140")), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 352 H534",
    stroke: "#E9EFF2"
  })), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 366,
    fontSize: 10.5,
    fontWeight: 700,
    fill: "#14344B"
  }, "Total before VAT")), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 366,
    fontSize: 10.5,
    fontWeight: 700,
    fill: "#14344B",
    textAnchor: "end"
  }, "28")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 534,
    y: 366,
    fontSize: 10.5,
    fontWeight: 700,
    fill: "#14344B",
    textAnchor: "end"
  }, "\u20B1770")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.ad6915bfb09804e303f1259e71b529ed.svg";
export { ForwardRef as ReactComponent };